import React, { useEffect, useState } from 'react'
import classnames from 'classnames'
import { CSSTransition } from 'react-transition-group'

import Dialog from '@react/react-spectrum/Dialog'
import Button from '@react/react-spectrum/Button'
import Edit from '@react/react-spectrum/Icon/Edit'

import RichTextEditor from './RichTextEditor'

export const RichTextFormField = ({ label, value, disabled, onChange }) => {
  const [isOpen, setIsOpen] = useState(false)
  return (
    <>
      <Button
        icon={<Edit />}
        onClick={(e) => {
          e.preventDefault()
          e.stopPropagation()
          setIsOpen(true)
        }}
      >
        Open Editor
      </Button>
      <RichTextDialog
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        label={label}
        value={value}
        onChange={onChange}
        disabled={disabled}
      />
    </>
  )
}

const RichTextDialog = ({ label, value, isOpen, onChange, onClose, disabled, ...otherProps }) => {
  const [newContent, setNewContent] = useState(value)

  useEffect(() => {
    setNewContent(value)
  }, [value])
  return (
    <>
      <div className={classnames('spectrum-Underlay', { 'is-open': isOpen })}></div>
      <Dialog
        {...otherProps}
        title={label}
        confirmLabel='Save'
        cancelLabel='Discard'
        onCancel={onClose}
        confirmDisabled={disabled}
        onConfirm={() => {
          onChange(newContent)
          onClose()
        }}
        open={isOpen}
        role='dialog'
      >
        <CSSTransition in={isOpen} timeout={200} classNames='display' unmountOnExit appear>
          <RichTextEditor content={value} onChange={(v) => setNewContent(v)} disabled={disabled} debounce={false} />
        </CSSTransition>
      </Dialog>
    </>
  )
}
